import type { WorkerAPI } from "../../types/WorkerAPI"

const internalCreateWorker = <T, R>(worker: Worker): WorkerAPI<T, R> => ({
  send: (message: any) => worker.postMessage(message),
  on: (handler: (data: any) => void) =>
    (worker.onmessage = (event: MessageEvent) => handler(event.data)),
})

export const CreateWorker = <T, R>(path: string | URL): WorkerAPI<T, R> =>
  internalCreateWorker(new Worker(path, { type: "module" }))

export const CreateWorkerFromSelf = <T, R>(): WorkerAPI<T, R> =>
  internalCreateWorker(self as unknown as Worker)
